import { render, staticRenderFns } from "./fee-lab-regime-cards.vue?vue&type=template&id=016ac9da&scoped=true&"
import script from "./fee-lab-regime-cards.vue?vue&type=script&lang=js&"
export * from "./fee-lab-regime-cards.vue?vue&type=script&lang=js&"
import style0 from "./fee-lab-regime-cards.vue?vue&type=style&index=0&id=016ac9da&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016ac9da",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VDivider,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('016ac9da')) {
      api.createRecord('016ac9da', component.options)
    } else {
      api.reload('016ac9da', component.options)
    }
    module.hot.accept("./fee-lab-regime-cards.vue?vue&type=template&id=016ac9da&scoped=true&", function () {
      api.rerender('016ac9da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/fee-fixo/components/fee-lab-regime-cards/fee-lab-regime-cards.vue"
export default component.exports